import { useRouter } from 'next/router'
import { pathTranslations } from '../i18n/next-translate-routes'

export default function useTransRoute(ssr: boolean = false) {
  const getTraduzione = (
    href: string,
    locale?: string | undefined,
    localePrefix: boolean = true
  ) => {
    const { locale: currentLocale } = ssr ? { locale: locale } : useRouter()

    const transLocale = locale || currentLocale

    // Get translated route for non-default locales
    const translatedPath = !pathTranslations[transLocale]?.[href]
      ? undefined
      : localePrefix
      ? `/${transLocale}${pathTranslations[transLocale]?.[href]}`
      : `${pathTranslations[transLocale]?.[href]}`

    // Set `as` prop to change displayed URL in browser
    const as = translatedPath ? translatedPath : undefined

    return { href: translatedPath || href, as }
  }

  return getTraduzione
}
